module.exports = __webpack_public_path__ + "img/9788970652665.b30ca66c.jpg";